export default __webpack_public_path__ + "static/media/dt-3.6c7923c5.webp";